const getModuleState = (state) => state.films;

export const getAllFilms = (state) => getModuleState(state).allFilms;
export const getAllCalifications = (state) => getModuleState(state).allCalifications;
export const getCarteleraFilmsByCinema = (state) => getModuleState(state).carteleraFilmsByCinema;
export const getFilmById = (state) => getModuleState(state).filmById;
export const getFilmBySlug = (state) => getModuleState(state).filmBySlug;
export const getFilmByCinema = (state) => getModuleState(state).filmByCinema;
export const getFilmByFilm = (state) => getModuleState(state).filmByFilm;